const ACK_KEY = 'cookie_notice_v1';
const ACK_EVENT = 'cookie-notice-acknowledged';

export function isCookieNoticeAcknowledged(): boolean {
  try {
    return localStorage.getItem(ACK_KEY) === '1';
  } catch {
    return true;
  }
}

export function acknowledgeCookieNotice(): void {
  try {
    localStorage.setItem(ACK_KEY, '1');
  } catch {
    // без localStorage плашка покажется снова при следующем запуске
  }
  window.dispatchEvent(new Event(ACK_EVENT));
}

export function onCookieNoticeAcknowledged(listener: () => void): () => void {
  window.addEventListener(ACK_EVENT, listener);
  return () => window.removeEventListener(ACK_EVENT, listener);
}
